import { render, staticRenderFns } from "./ResidentLabel.vue?vue&type=template&id=2fa2ebb0&scoped=true&"
import script from "./ResidentLabel.vue?vue&type=script&lang=ts&"
export * from "./ResidentLabel.vue?vue&type=script&lang=ts&"
import style0 from "./ResidentLabel.vue?vue&type=style&index=0&id=2fa2ebb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa2ebb0",
  null
  
)

export default component.exports